/**
 * PicBatchPrint — まとめて印刷 for the 受信依頼 PIC inbox.
 * Opens at /shizai/requests/print-batch?ids=a,b,c and stacks one A4
 * 発注依頼書 per request (page-break between sheets). Uses the PIC
 * endpoints so it works while the 資材 module is paused.
 */
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { shizaiApi } from './shizaiApi';
import { ReceiptSheet } from './RequestReceiptPrint';

export default function PicBatchPrint() {
  const [params] = useSearchParams();
  const [reqs, setReqs] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const ids = (params.get('ids') || '').split(',').filter(Boolean);
    shizaiApi.picRequests()
      .then((rows) => {
        const map = Object.fromEntries(rows.map((r) => [r.id, r]));
        setReqs(ids.map((id) => map[id]).filter(Boolean));
      })
      .catch((e) => setError(e?.response?.data?.detail || '依頼を読み込めませんでした'));
  }, [params]);

  if (error) return <div className="p-12 text-center text-sm text-rose-600" data-testid="batch-print-error">{error}</div>;
  if (!reqs) return <div className="p-12 text-center text-sm text-zinc-500">読み込み中…</div>;

  return (
    <>
      <style>{`
        @page { size: A4; margin: 14mm 14mm 14mm 14mm; }
        @media print {
          body { background: #fff !important; }
          .no-print { display: none !important; }
          .receipt-page { box-shadow: none !important; padding: 0 !important; margin: 0 !important; }
          .batch-sheet { page-break-after: always; }
          .batch-sheet:last-child { page-break-after: auto; }
          [data-testid="chat-fab"], [data-sonner-toaster], .fixed { display: none !important; }
        }
        @media screen { body { background: #f4f4f5; } }
      `}</style>

      <div className="no-print sticky top-0 z-10 bg-white border-b border-zinc-200 px-4 py-2 flex items-center justify-between shadow-sm" data-testid="batch-print-toolbar">
        <div className="text-sm text-zinc-600">
          発注依頼書まとめて印刷 — <span className="font-semibold text-zinc-800">{reqs.length}件</span>
        </div>
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => window.print()}
            className="px-3 py-1.5 rounded bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700"
            data-testid="batch-print-print-btn">
            印刷 / PDF保存
          </button>
          <button type="button" onClick={() => window.close()}
            className="px-3 py-1.5 rounded border border-zinc-200 text-sm text-zinc-600 hover:bg-zinc-50"
            data-testid="batch-print-close-btn">
            閉じる
          </button>
        </div>
      </div>

      {reqs.length === 0 ? (
        <div className="p-12 text-center text-sm text-zinc-500" data-testid="batch-print-empty">対象の依頼がありません</div>
      ) : (
        reqs.map((r) => (
          <div key={r.id} className="batch-sheet">
            <ReceiptSheet req={r} />
          </div>
        ))
      )}
    </>
  );
}
